import React from "react";

import * as Icons from "Components/icons/integrations";

const ICONS = {
  bitbucket: "Bitbucket",
  bitbucket_server: "Bitbucket",
  github: "GitHub",
  gitlab: "Gitlab",
  hipchat: "Hipchat",
  webhook: "Webhook",
  "health.email": "Email",
  "health.pagerduty": "Pagerduty",
  "health.slack": "Slack",
  "health.webhook": "Webhook",
  script: "Script",
  blackfire: "BlackFire",
  syslog: "Syslog",
  splunk: "Splunk",
  sumologic: "Sumologic",
  newrelic: "Newrelic",
  httplog: "HttpLog"
} as const;

type IntegrationIconProps = {
  type?: string;
  size?: string;
};

const IntegrationIcon = ({ type, size }: IntegrationIconProps) => {
  if (!type) return null;

  const name: (typeof ICONS)[keyof typeof ICONS] | "default" =
    ICONS[type] || "default";
  const Icon: (typeof Icons)[keyof typeof Icons] | undefined = Icons[name];

  if (!Icon) return null;
  return <Icon size={size} />;
};

export default IntegrationIcon;
